import React from 'react';

const BackgroundAnimation = () => {
    return (
        <ul className="circles">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>
      );
}
 
export default BackgroundAnimation;